<template>
  <div class="page">
    <form @keyup.enter="saveCorporateDetails">
      <!-- <form> -->
      <ion-grid fixed>
        <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
          <ion-col>
            <ion-row align-items-stretch>
              <!-- <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder="Enter Name"
                    @input="corporateName = $event.target.value"
                    :value="corporateName"
                    maxlength="10"
                  ></ion-input>
                </div>
              </ion-col> -->

              <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Name
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line select-mobile readonly">
                    <ion-select
                      class="form-select"
                      :value="corporateName"
                      @ionChange="corporateName = $event.target.value"
                      placeholder="Select corporate name"
                      interface="action-sheet"
                    >
                      <ion-select-option
                        v-for="(corporateName, index) in this.corporateNameList"
                        :key="index"
                        :value="corporateName.corporateName"
                      >{{corporateName.corporateName}}</ion-select-option>
                    </ion-select>
                  </div>
                  <div class="border-line select-web">
                    <!-- <select class="input-select" v-model="corporateName" :disabled="this.corporateNameList != null ? true : false" placeholder="Select corporate name"> -->
                      <select class="input-select" v-model="corporateName" :disabled="getPermission('corporateName')" placeholder="Select corporate name">
                      <option
                        v-for="(val, index) in this.corporateNameList"
                        :key="index"
                        :value="val.corporateName"
                      >{{val.corporateName}}</option>
                    </select>
                  </div>
                </ion-col>
              <!-- <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                    Corporate Alias Name
                  </ion-label>
                  <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Corporate Alias Name"
                    @input="corporateAliasName = $event.target.value"
                    :value="corporateAliasName"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col> -->
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                    Branch
                    <span class="required">*</span>
                  </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Branch"
                    @input="branch = $event.target.value"
                    :value="branch"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                    Mobile#1
                    <span class="required">*</span>
                  </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="number"
                    placeholder="Enter Mobile Number"
                    @input="mobile1 = $event.target.value"
                    :value="mobile1"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Mobile#2
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="number"
                    placeholder="Enter  Mobile Number"
                    @input="mobile2 = $event.target.value"
                    :value="mobile2"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              
              <!-- <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Fax Number
                  
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Fax Number"
                    @input="faxNumber = $event.target.value"
                    :value="faxNumber"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Landline
                  
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="number"
                    placeholder="Enter Landline"
                    @input="landline = $event.target.value"
                    :value="landline"
                    maxlength="200"
                    :disabled="getPermission('landline')"
                  ></ion-input>
                </div>
              </ion-col> -->
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Primary Contact Person
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Primary Contact Person"
                    @input="primaryContactPerson = $event.target.value"
                    :value="primaryContactPerson"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Secondary Contact Person
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Secondary Contact Person"
                    @input="secondaryContactPerson = $event.target.value"
                    :value="secondaryContactPerson"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  GST Number
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter GST Number"
                    @input="gstNumber = $event.target.value"
                    :value="gstNumber"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <!-- <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  PAN#
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter PAN Number"
                    @input="panNo = $event.target.value"
                    :value="panNo"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col> -->
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Email
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder="Enter Email"
                    @input="email = $event.target.value"
                    :value="email"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Status
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line select-mobile">
                    <ion-select
                      class="form-select"
                      :value="status"
                      @ionChange="status = $event.target.value"
                      placeholder="Select Status"
                      interface="action-sheet"
                    >
                      <ion-select-option
                        v-for="(status, index) in this.statuses"
                        :key="index"
                        :value="status"
                      >{{status}}</ion-select-option>
                    </ion-select>
                  </div>
                  <div class="border-line select-web">
                    <select class="input-select" v-model="status" placeholder="Select Status">
                      <option
                        v-for="(val, index) in this.statuses"
                        :key="index"
                        :value="val"
                      >{{val}}</option>
                    </select>
                  </div>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="secondary-text">Address</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Building Name
                    <!-- <span class="required">*</span> -->
                  </ion-label>
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="text"
                      placeholder="Enter Building Name"
                      @input="line1 = $event.target.value"
                      :value="line1"
                      maxlength="100"
                    ></ion-input>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Street Address
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="text"
                      placeholder="Enter Street Address"
                      @input="line2 = $event.target.value"
                      :value="line2"
                      maxlength="100"
                    ></ion-input>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row align-items-stretch>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Area Name
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="text"
                      placeholder="Enter Area Name"
                      @input="line3 = $event.target.value"
                      :value="line3"
                      maxlength="100"
                    ></ion-input>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    City
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="text"
                      placeholder="Enter City"
                      @input="city = $event.target.value"
                      :value="city"
                      maxlength="100"
                    ></ion-input>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row align-items-stretch>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    State
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line select-mobile">
                    <ion-select
                      :value="state"
                      class="form-select popover-content"
                      @ionChange="state = $event.target.value"
                      placeholder="Select State"
                      interface="action-sheet"
                    >
                      <ion-select-option  v-for="(state, index) in this.states"
                        :key="index"
                        :value="state.code"
                      >{{state.name}}
                        
                      </ion-select-option>
                    </ion-select>
                  </div>
                  <div class="border-line select-web">
                    <select class="input-select select-s" v-model="state" placeholder="Select State" >
                      <option
                        v-for="(state, index) in this.states"
                        :key="index"
                        :value="state.code"
                      >{{ state.name }}</option>
                    </select>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="6" class="col-padding">
                  <ion-label class="border-text" position="stacked">
                    Pincode
                    <span class="required">*</span>
                  </ion-label>
                  <div class="border-line">
                    <ion-input
                      class="form-input"
                      type="text"
                      placeholder="Enter Pincode"
                      @input="zipcode = $event.target.value"
                      :value="zipcode"
                      maxlength="6"
                    ></ion-input>
                  </div>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" class="col-nopadding ion-text-right">
              <ion-button class="btn-primary" @click="cancel">Cancel</ion-button>
              <ion-button class="btn-primary" @click="saveCorporateDetails">Save</ion-button>
            </ion-col>
          </ion-row>
      </ion-grid>
      <!-- <div text-center>
        <ion-button class="btn-primary" expand="full" @click="signUp">GENERATE OTP</ion-button>
      </div>-->
      <!-- <div text-center>
        <ion-row>
          <ion-col class="col-padding">
            <ion-button expand="block" class="btn-primary" @click="saveCorporateDetails">Save</ion-button>
          </ion-col>
        </ion-row>
      </div> -->
    </form>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { ProfilerService } from "../../service/profile/profiler.service";
import { LocationService } from "../../service/location/location.service";

import { LocalStorage } from "../../data/localstorage";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

import { CorporateService } from "../../service/corporate/corporate.service";
import { CorporateDetails } from "../../entity/corporate/corporateDetails";
import { CorporateAddress } from '@/entity/corporate/corprateAddress';
import { CorporateState } from '@/entity/corporate/corporateState';
import { IonButton, IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";

export default defineComponent ({
  name: 'corporateManage',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonSpinner
  },
  data() {
    return {
      loaderTab: true,
      mode: "ADD",
      columnEditPermission: [],
      states: "",
      corporateNameList: [],
      id: "",
      corporateName: "",
      corporateAliasName: "",
      branch: "",
      mobile1: "",
      mobile2: "",
      email: "",
      faxNumber: "",
      landline: "",
      primaryContactPerson: "",
      secondaryContactPerson: "",
      gstNumber: "",
      panNo: "",
      status: "",
      line1: "",
      line2: "",
      line3: "",
      city: "",
      state: "",
      zipcode: "",
      statuses: ["Active","Retired"]
    }
  },
  async mounted() {
    let states = await new LocationService().states();
    this.states = states;
    let profile = await new CorporateService().getCorporates(
    new LocalStorage().user
    );
    if (this.$route.params.corporateId) {
    let corporateDetails = await new CorporateService().getCorporateDetailsById(
        this.$route.params.corporateId
    );
    this.fillCorporateDetails(corporateDetails);
    }
    if(this.mode == "ADD") {
    this.columnEditPermission = await new CorporateService().corporateEditPermission();
    this.loaderTab = false;
    }
    
    this.corporateNameList = profile;
    // this.fillProfile(profile);
    // this.loaderTab = false;
  },
  methods: {
    fillProfile(profile) {

      // this.line1 = profile.address.line1;
      // this.line2 = profile.address.line2;
      // this.line3 = profile.address.line3;
      // this.city = profile.address.city;
      // this.state = profile.address.state.code;
      // this.zipcode = profile.address.zipcode;
    },
    fillCorporateDetails(corporate) {
      this.mode = "UPDATE";
      this.id = corporate.corporateHdrId;
      this.corporateName = corporate.corporateName;
      this.corporateAliasName = corporate.corporateAliasName;
      this.branch = corporate.branch;
      this.mobile1 = corporate.mobilePrimaryContact;
      this.primaryContactPerson = corporate.primaryContactPerson;
      this.gstNumber = corporate.gstNumber;
      this.panNo = corporate.panNumber;
      this.email = corporate.email;
      this.status = corporate.status;
      this.mobile2 = corporate.mobileSecondaryContact;
      this.faxNumber = corporate.faxNumber;
      this.landline = corporate.landline;
      this.secondaryContactPerson = corporate.secondaryContactPerson
      this.line1 = corporate.addressLine1;
      this.line2 = corporate.addressLine2;
      this.line3 = corporate.addressLine3;
      this.city = corporate.city;
      this.state = corporate.state;
      this.zipcode = corporate.pincode;
    },
    getPermission(columnName) {
      
      if(this.columnEditPermission.data) {
        for(let i = 0; i < this.columnEditPermission.data.length; i++) {
          if(columnName == this.columnEditPermission.data[i].columnName && this.columnEditPermission.data[i].editPermission == "T") {
            return true;
          }
        }
      }
      
      this.loaderTab = false;
    },
    async saveCorporateDetails() {
      try {
          if (
            typeof this.corporateName === "undefined" ||
            this.corporateName === null ||
            this.corporateName === "" ||
            this.corporateName.trim().length === 0
          ) {
            new ToastUtils().presentToast("Select Corporate Name");
          } 
          // else if (
          //   typeof this.branch === "undefined" ||
          //   this.branch === null ||
          //   this.branch === "" ||
          //   this.branch.trim().length === 0
          // ) {
          //     new ToastUtils().presentToast("Enter Branch");
          // } else if (
          //   typeof this.mobile1 === "undefined" ||
          //   this.mobile1 === null ||
          //   this.mobile1 === "" ||
          //   this.mobile1.trim().length === 0
          // ) {
          //     new ToastUtils().presentToast("Enter Mobile Number");
          // } else if(new ValidationUtils().mobile(this.mobile1) === false) {
          //     new ToastUtils().presentToast("Enter Valid Mobile Number");
          // } else if(
          //   typeof this.primaryContactPerson === "undefined" ||
          //   this.primaryContactPerson === null ||
          //   this.primaryContactPerson === "" ||
          //   this.primaryContactPerson.trim().length === 0
          //   ) {
          //   new ToastUtils().presentToast("Enter Primary Contact Person"); 
          // } else if(this.gstNumber == "undefined" || 
          //   this.gstNumber === null || this.gstNumber === "" || 
          //   this.gstNumber.trim().length === 0
          //   ) {
          //     new ToastUtils().presentToast("Enter GST Number"); 
          // } else if(this.panNo == "undefined" || 
          //   this.panNo === null || this.panNo === "" || 
          //   this.panNo.trim().length === 0
          //   ) {
          //     new ToastUtils().presentToast("Enter PAN Number"); 
          // } else if(this.email == "undefined" || 
          //   this.email === null || this.email === "" || 
          //   this.email.trim().length === 0
          //   ) {
          //     new ToastUtils().presentToast("Enter Email Number"); 
          // } else if(new ValidationUtils().email(this.email) === false) {
          //     new ToastUtils().presentToast("Enter Valid Email Address");
          // } 
          
          // else if(this.status == "undefined" || this.status === null || this.status === "" || this.status.trim().length === 0) {
          //     new ToastUtils().presentToast("Select Status");
          // } else if (
          //   typeof this.line2 === "undefined" ||
          //   this.line2 === null ||
          //   this.line2 === "" ||
          //   this.line2.trim().length === 0
          // ) {
          //   new ToastUtils().presentToast("Enter Street Address");
          // } else if (
          //   typeof this.line3 === "undefined" ||
          //   this.line3 === null ||
          //   this.line3 === "" ||
          //   this.line3.trim().length === 0
          // ) {
          //   new ToastUtils().presentToast("Enter Area Name");
          // } else if (
          //   typeof this.city === "undefined" ||
          //   this.city === null ||
          //   this.city === "" ||
          //   this.city.trim().length === 0
          // ) {
          //   new ToastUtils().presentToast("Enter City");
          // } 
          // else if (
          //   typeof this.state === "undefined" ||
          //   this.state === null ||
          //   this.state === ""
          // ) {
          //   new ToastUtils().presentToast("Select State");
          // } else if (
          //   typeof this.zipcode === "undefined" ||
          //   this.zipcode === null ||
          //   this.zipcode === "" ||
          //   this.zipcode.trim().length === 0
          // ) {
          //   new ToastUtils().presentToast("Enter Pincode");
          // } 
          else {
            let corporateDetails = null;
            if(this.mode == "ADD") {
              await new CorporateService().createCorporateDetailsByAuthor(
                new CorporateDetails(
                  this.corporateName,
                  this.corporateAliasName,
                  this.branch,
                  this.mobile1,
                  this.primaryContactPerson,
                  this.gstNumber,
                  this.panNo,
                  this.email,
                  this.status,
                  this.mobile2,
                  this.faxNumber,
                  this.landline,
                  this.secondaryContactPerson,
                  new CorporateAddress(
                    this.line1.trim(),
                    this.line2.trim(),
                    this.line3.trim(),
                    "",
                    this.city.trim(),
                    new CorporateState(this.state),
                    this.zipcode
                  )
                ), 
                new LocalStorage().user
              ).then((data) => {
                new ToastUtils().presentToast("Corporate details saved successfully");
                this.$router.back();
              }).catch((error) => {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
              });
              
            } else {
              await new CorporateService().updateCorporateDetailsByAuthor(
                new CorporateDetails(
                  this.corporateName,
                  this.corporateAliasName,
                  this.branch,
                  this.mobile1,
                  this.primaryContactPerson,
                  this.gstNumber,
                  this.panNo,
                  this.email,
                  this.status,
                  this.mobile2,
                  this.faxNumber,
                  this.landline,
                  this.secondaryContactPerson,
                  new CorporateAddress(
                    this.line1.trim(),
                    this.line2.trim(),
                    this.line3.trim(),
                    "",
                    this.city.trim(),
                    new CorporateState(this.state),
                    this.zipcode
                  )
                ), 
                new LocalStorage().user,
                this.id
              ).then((data) => {
                new ToastUtils().presentToast("Corporate details updated successfully");
                this.$router.back();
              }).catch((error) => {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
              });
            }
          }
      } catch(err) {
          alert(err)
      }
    },
    cancel() {
      this.$router.back();
    },
  }
})
</script>

<style scoped>
.carImage {
  width: 10rem;
}
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
</style>